import { render, staticRenderFns } from "./TheCompatibles.vue?vue&type=template&id=559c5bc8"
import script from "./TheCompatibles.vue?vue&type=script&lang=js"
export * from "./TheCompatibles.vue?vue&type=script&lang=js"
import style0 from "./TheCompatibles.vue?vue&type=style&index=0&id=559c5bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports